
import { ConsentStatus, CONSENT_STATUS_ENUM } from '@/common/gaHelper';
import { bootstrap } from 'vue-gtag';
import { Vue, Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const analyticsConsentModule = namespace('analyticsConsent');

@Component
export default class ConsentGA extends Vue {
  @analyticsConsentModule.Mutation('setConsentStatus') setConsentStatus!: (consent: ConsentStatus) => void;

  acceptConsent () {
    bootstrap().then(() => {
      this.setConsentStatus(CONSENT_STATUS_ENUM.ACCEPTED);
    });
  }

  declineConsent () {
    this.setConsentStatus(CONSENT_STATUS_ENUM.REJECTED);
    this.$gtag.optOut();
  }
}
